module.exports = __webpack_public_path__ + "img/white-hamburger.a7627c80.svg";